import { Theme } from "@emotion/react";

const NewTheme: Theme = {
  typography: {
    fontFamily: ["dm-sans", "Open Sans", "sans-serif"].join(","),
    h1: {
      fontWeight: 600,
      fontSize: "40px",
    },
    h2: {
      fontWeight: 600,
      fontSize: "23px",
    },
    h3: {
      fontWeight: 600,
      fontSize: "23px",
    },
    h4: {
      fontWeight: 600,
      fontSize: "23px",
    },
    h5: {
      fontWeight: 600,
      fontSize: "23px",
    },
  },
  palette: {
    primary: {
      dark: "#0A9640",
      main: "#005faa",
      light: "#D2F5E1",
      contrastText: "#FFFFFF",
    },
    secondary: {
      dark: "#8737EF",
      main: "#9747FF",
      light: "#A757FF",
      contrastText: "#FFFFFF",
    },
    light: {
      dark: "#C2E5D1",
      main: "#D2F5E1",
      light: "#F1FCF6",
    },
    dark: {
      dark: "#000000",
      main: "#000000",
      light: "#00D880",
      contrastText: "#FFFFFF",
    },
    success: {
      light: "#00D880",
      main: "#0A9640",
      dark: "#165233",
      contrastText: "#FFFFFF",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "h2" },
              style: {
                marginBottom: "1em",
              },
            },
            {
              props: { variant: "h3" },
              style: {
                marginBottom: "1em",
              },
            },
            {
              props: { variant: "h4" },
              style: {
                marginBottom: "1em",
              },
            },
          ],
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderWidth: "1px",
          borderRadius: 0,
          fontSize: "1rem",
          textTransform: "none",
          fontWeight: 600,
          padding: ".75rem 2.5rem",
          boxShadow: "none",
          "&:hover, &:focus": {
            borderWidth: "1px",
            boxShadow: "none",
          },
          variants: [
            {
              props: { size: "small" },
              style: {
                padding: ".25rem 1rem",
                minWidth: "unset",
                fontSize: ".85rem",
              },
            },
            {
              props: { variant: "text" },
              style: {
                padding: "0",
                minWidth: "unset",
              },
            },
          ],
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: "0px !important",
          borderWidth: "1px",
          backgroundColor: "#005faa",
          borderColor: "#000000",
          borderStyle: "solid",
          outline: "unset",
          "&:hover, &:focus": {
            outline: "unset",
            borderWidth: "1px",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid",
          borderColor: "#000000",
          borderRadius: "0px",
          boxShadow: "none",
          padding: "2rem",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingLeft: "4px",
          paddingRight: "4px",
        },
      },
    },
  },
};

export default NewTheme;
